import { useDispatch, useSelector } from "react-redux";
import { toggleAreaDesarrolloActiveThunk } from "../../store/reducers/fortalezas/fortalezas.thunks";
import Modal from "../UI/Modal";
import Loader from "../UI/Loader";
import { closeAreaConfirmToggle } from "../../store/reducers/fortalezas/fortalezas.reducer";

const ConfirmToggleAreaModal = () => {
  const dispatch = useDispatch();
  const { areaConfirmModalOpen, toggleAreaId, areaToggling } = useSelector(
    (state) => state.fortalezas
  );

  const area = useSelector((state) =>
    state.fortalezas.areasList.find((a) => a.id === toggleAreaId)
  );

  const handleConfirm = () => {
    dispatch(toggleAreaDesarrolloActiveThunk(toggleAreaId));
  };

  return (
    <Modal
      open={areaConfirmModalOpen}
      onClose={() => dispatch(closeAreaConfirmToggle())}
      title="Confirmación"
      size="sm"
    >
      {areaToggling ? (
        <Loader center text="Actualizando área..." type="dots" size="sm" />
      ) : (
        <>
          <p className="mb-3">
            ¿Seguro que quieres{" "}
            <strong>{area?.is_active ? "desactivar" : "activar"}</strong> el
            área <strong>"{area?.area}"</strong>?
          </p>

          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-secondary"
              onClick={() => dispatch(closeAreaConfirmToggle())}
            >
              Cancelar
            </button>
            <button className="btn btn-primary" onClick={handleConfirm}>
              Confirmar
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ConfirmToggleAreaModal;
